<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.25 21.25L27.5 15L21.25 8.75M8.75 8.75L2.5 15L8.75 21.25M17.5 3.75L12.5 26.25"
      :stroke="color"
      stroke-width="2.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
// Props
const props = defineProps({
  color: {
    type: String,
    default: "#6434D0",
  },
});
</script>
